jQuery(document).ready(function() {
    // const cloned = $(".tmenu_submenu_tab_active").clone();
    // console.log(cloned);

    // Enable currency dropdown



    $('#currency-button-footer .button-contents').on('click', function(e) {
        if($('#currency-selection-footer').hasClass("show")){
            $('#currency-selection-footer').removeClass('show');
        }
        else{
            $('#currency-selection-footer').addClass('show');
        }

    });





    $('#currency-button-2 .button-contents').on('click', function(e) {
        if($('#currency-selection-2').hasClass("show")){
            $('#currency-selection-2').removeClass('show');
        }
        else{
            $('#currency-selection-2').addClass('show');
        }
    });



    // On selecting currency
    // $('.currency-option').on('click', function() {
    //     var thisCurrency = $(this);

    //     fetchExchangeRate();
    //     convertPrices(thisCurrency);

    //     sessionStorage.setItem('currency', thisCurrency.attr('id'));

    //     location.reload();
    // });

  });


  function showPassword() {
  var x = document.getElementById("customer-login-password");
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
  }



//   jQuery(window).on('load', function() {
//     var hasSelectedCurrency = sessionStorage.getItem('currency');

//     // Set GBP as base
//     sessionStorage.setItem('prevCurrency', 'GBP');

//     // Fetch exchange rate or use stored
//     if( hasSelectedCurrency ) {
//         setCurrency();
//     }
//   });

//   var setCurrency = function() {
//     var selectedCurrency = sessionStorage.getItem('currency');
//     var isEuro = sessionStorage.getItem('isEuro');

//     if( selectedCurrency ) {

//         fetchExchangeRate();
//         convertPrices($('#' + selectedCurrency));
//     } else if( isEuro ) {


//         fetchExchangeRate();
//         convertPrices($('#eur'));
//     }
//         $('.button-contents').addClass(selectedCurrency);

//   };

//   var fetchExchangeRate = function() {
//     var gbpRate = sessionStorage.getItem('gbpRate');
//     var eurRate = sessionStorage.getItem('eurRate');
//     var usdRate = sessionStorage.getItem('usdRate');

//     if( !gbpRate ) {
//         // Load Exchange Rates
//         $.get('https://openexchangerates.org/api/latest.json', {app_id: 'dcdf281137314191a292eb207c059c5a'}, function(data) {
//             // Check money.js has finished loading:
//             if ( typeof fx !== "undefined" && fx.rates ) {
//                 fx.rates = data.rates;
//                 fx.base = data.base;
//             }
//             else {
//                 // If not, apply to fxSetup global:
//                 var fxSetup = {
//                     rates : data.rates,
//                     base : data.base
//                 };
//             }
//         })
//         .done(function() {
//             sessionStorage.setItem('gbpRate', fx.rates.GBP);
//             sessionStorage.setItem('eurRate', fx.rates.EUR);
//             sessionStorage.setItem('usdRate', fx.rates.USD);
//         });
//     }
//     else {
//         fx.base = 'USD';
//         fx.rates = {
//             'GBP' : gbpRate,
//             'EUR' : eurRate,
//             'USD' : usdRate
//         };
//     }
//   };

//   var convertPrices = function(chosenCurrency) {
//     if( chosenCurrency == null ) {
//         currency = $('.currency-option.active');
//     } else {
//         currency = chosenCurrency;
//     }
//     var prevCurrency = sessionStorage.getItem('prevCurrency').toUpperCase();
//     var selectedCurrency = currency.attr('id');
//     var selectedCurrencySign = currency.find('.sign').html();
//     var currencyFormatted = selectedCurrency.toUpperCase();

//     //add classes for flag icon
//     $('.button-contents').attr("class","button-contents");
//     $('.button-contents').addClass(selectedCurrency);

//     // Close Selections
//     $('#currency-selection').removeClass('show');
//     $('#currency-selection-footer').removeClass('show');
//     $('#currency-selection-2').removeClass('show');

//     // Active
//     $('.currency-option').removeClass('active');
//     currency.addClass('active');

//     // Switch Icon
//     $('.currency-selected').removeClass('active');
//     $('[data-id=' + selectedCurrency + ']').addClass('active');

//     // Change Currency
//     $('.price').each(function() {
//         var thisEl = $(this);
//         var thisPrice = thisEl.attr('data-price');
//         var thisVisiblePrice = thisEl.attr('data-price-visible');

//         if( thisPrice ) {
//             var thisPriceConverted = fx(thisPrice).from(prevCurrency).to(currencyFormatted);
//             var thisPriceToDecimal = thisPriceConverted.toFixed(2);
//             thisEl.attr('data-price', selectedCurrencySign + thisPriceToDecimal);
//             var gbpRate = sessionStorage.getItem('gbpRate');

//             if( gbpRate ) {
//                 if( chosenCurrency == null ) {
//                     currency = $('.currency-option.active');
//                 }
//             }

//         } else {
//             if( thisVisiblePrice ) {
//                 var thisVisiblePriceConverted = fx(thisVisiblePrice).from(prevCurrency).to(currencyFormatted);
//                 var thisVisiblePriceToDecimal = thisVisiblePriceConverted.toFixed(2);
//                 thisEl.attr('data-price-visible', selectedCurrencySign + thisVisiblePriceToDecimal);
//                 thisEl.html(selectedCurrencySign + thisVisiblePriceToDecimal);
//             }
//             else {
//                 thisEl.html(selectedCurrencySign);
//             }
//             currency = chosenCurrency;
//         }
//     });

//     // Log Session Storage
//     sessionStorage.setItem('currency', selectedCurrency);
//     sessionStorage.setItem('prevCurrency', selectedCurrency);
//   };

  jQuery(document).ready(function() {
    var
    dropdown = $('.stylized-dropdown'),
    dropdown_selected = dropdown.find('.dropdown-selected'),
    dropdown_contents = dropdown.find('.dropdown-contents'),
    dropdown_option = dropdown.find('.dropdown-option');

    dropdown_selected.on('click', function() {
        if( dropdown_contents.hasClass('active') ) {
            dropdown_contents.removeClass('active');
        }
        else {
            dropdown_contents.addClass('active');
        }
    });
    dropdown_option.on('click', function() {
        var this_option = $(this);
        var this_data = this_option.attr('data-value');
        dropdown_selected.attr('data-value', this_data);

        dropdown_selected.html( this_option.html() );
        dropdown_contents.removeClass('active');
    });

  });

  jQuery(window).on('load', function() {
    var objects = $('main, #inner-page-title, #inner-page-featured-image, #product-left-column, .hero-image, #cart-button .circle-button-contents, #currency-button .circle-button-contents');
    var logo = $('#hero-logo');
    objects.addClass('loaded');
    logo.addClass('loaded');

    /*
    --Need to wait for approval until push this
    var productPg = $('.template-product');
    if(productPg){
        $('html, body').animate({
            scrollTop: $('.template-product').offset().top
        }, 10);
    }*/

    // COOKIE NOTICE
    if( localStorage.getItem('cookies') != 'accepted' ) {
        $('#cookie-notice').addClass('show');
    }
    else {
        $('#cookie-notice').remove();
    }

    $('#cookies-notice-accept').on('click', function() {
        localStorage.setItem('cookies', 'accepted');
        $('#cookie-notice').removeClass('show');
        setTimeout(function() {
            $('#cookie-notice').remove();
        }, 1000);
    });
  });

  // /* global $ jQuery */

  // jQuery(document).ready(function() {
  //     var loading_screen = $('#loading-overlay');

  //     // FAVOURITE BUTTON
  //     var
  //     shop = 'armac-martin',
  //     toast_remove = '<h6>Removed from favourites</h6>',
  //     toast_add = '<h6>Added to favourites</h6>',
  //     fail_message = 'Failed. Please try again.',
  //     title_remove = 'Remove from favourites',
  //     title_add = 'Add to favourites',
  //     favourite_button = $('.favourite-button');

  //     function collection_favourite_sort() {
  //         $('.product').each(function() {
  //             var handle = $(this).data('handle'),
  //             icon = $(this).find('.favourite-icon'),
  //             favourites_list = $('#favourite-list #favourite-list-contents');

  //             if( favourites_list.html().indexOf(handle + ',') > -1 ) {
  //                 icon.addClass('favourited');
  //                 icon.attr('title', title_remove);
  //             }
  //             else {
  //                 icon.removeClass('favourited');
  //                 icon.attr('title', title_add);
  //             }
  //         });
  //     }
  //     function favourite_list_update() {
  //         var url = window.location.href;
  //         $.get({
  //             url: url,
  //             success: function(data) {
  //                 $('#favourite-list').load( url + " #favourite-list > *" );
  //             }
  //         });
  //     }
  //     function refresh_favourites() {
  //         var url = window.location.href;
  //         if( $('#account-favourites').length ) {
  //             setTimeout(function() {
  //                 $.get({
  //                     url: url,
  //                     success: function(data) {
  //                         $('#account-favourites #account-page-information').load( url + " #account-favourites #account-page-information > *" );
  //                     }
  //                 });
  //             }, 600);
  //         }
  //     }

  //     // FAVOURITE BUTTON TOGGLE
  //     $('body').on('click', '.favourite-button', function() {
  //         var
  //         handle = $(this).closest('.product').data('handle'),
  //         favourites_list = $('#favourite-list #favourite-list-contents'),
  //         icon = $(this),
  //         toast_message = $(this).closest('.product').find('.favourite-toast');

  //         function show_toast_message() {
  //             if( toast_message.hasClass('active') ) {
  //                 toast_message.removeClass('active');
  //                 toast_message.addClass('active');
  //             }
  //             else {
  //                 toast_message.addClass('active');
  //             }

  //             setTimeout(function() {
  //                 toast_message.removeClass('active');
  //             }, 3000);
  //         }

  //         // REMOVE FAVOURITE IF FOUND
  //         if( favourites_list.html().indexOf( handle + ',' ) > -1 ) {
  //             var
  //             remove_data = favourites_list.html().replace(handle + ',', '');

  //             if( (favourites_list.html().match(/,/g)||[]).length == 1 ) {
  //                 $.post(
  //                     'https://metafields-manager.thebestagency.com/proxy/metafield', {
  //                         type: 'customer',
  //                         id: '4610150795',
  //                         shop: shop,
  //                         namespace: 'global',
  //                         key: 'favourites',
  //                         value: '#',
  //                         beforeSend: function() {
  //                             loading_screen.addClass('loading');
  //                         },
  //                         error: function() {
  //                             loading_screen.removeClass('loading');
  //                             toast_message.html(fail_message);
  //                         },
  //                         success: function() {
  //                             loading_screen.removeClass('loading');
  //                             favourite_list_update();
  //                             toast_message.html(toast_remove);
  //                             show_toast_message();
  //                             refresh_favourites();

  //                             if( $('#account-favourites').length ) {
  //                                 icon.closest('.product').fadeOut(600);
  //                             }
  //                         }
  //                     }
  //                 );
  //             }
  //             else {
  //                 $.post(
  //                     'https://metafields-manager.thebestagency.com/proxy/metafield', {
  //                         type: 'customer',
  //                         id: '4610150795',
  //                         shop: shop,
  //                         namespace: 'global',
  //                         key: 'favourites',
  //                         value: remove_data,
  //                         beforeSend: function() {
  //                             loading_screen.addClass('loading');
  //                         },
  //                         error: function() {
  //                             loading_screen.removeClass('loading');
  //                             toast_message.html(fail_message);
  //                         },
  //                         success: function() {
  //                             loading_screen.removeClass('loading');
  //                             refresh_favourites();
  //                             toast_message.html(toast_remove);
  //                             show_toast_message();
  //                             favourite_list_update();

  //                             if( $('#account-favourites').length ) {
  //                                 icon.closest('.product').fadeOut(600);
  //                             }
  //                         }
  //                     }
  //                 );
  //             }
  //         }
  //         // ADD IF NOT
  //         else {
  //             var
  //             new_data = favourites_list.html() + handle + ',',
  //             new_list = favourites_list.html().replace('#', handle + ',');

  //             if( favourites_list.html() == '#' ) {
  //                 $.post(
  //                     'https://metafields-manager.thebestagency.com/proxy/metafield', {
  //                         type: 'customer',
  //                         id: '4610150795',
  //                         shop: shop,
  //                         namespace: 'global',
  //                         key: 'favourites',
  //                         value: new_list,
  //                         beforeSend: function() {
  //                             loading_screen.addClass('loading');
  //                         },
  //                         error: function() {
  //                             loading_screen.removeClass('loading');
  //                             toast_message.html(fail_message);
  //                             show_toast_message();
  //                         },
  //                         success: function() {
  //                             loading_screen.removeClass('loading');
  //                             favourite_list_update();
  //                             toast_message.html(toast_add);
  //                             show_toast_message();
  //                         }
  //                     }
  //                 );
  //             }
  //             else {
  //                 $.post(
  //                     'https://metafields-manager.thebestagency.com/proxy/metafield', {
  //                         type: 'customer',
  //                         id: '4610150795',
  //                         shop: shop,
  //                         namespace: 'global',
  //                         key: 'favourites',
  //                         value: new_data,
  //                         beforeSend: function() {
  //                             loading_screen.addClass('loading');
  //                         },
  //                         error: function() {
  //                             loading_screen.removeClass('loading');
  //                             toast_message.html(fail_message);
  //                             show_toast_message();
  //                         },
  //                         success: function() {
  //                             loading_screen.removeClass('loading');
  //                             favourite_list_update();
  //                             toast_message.html(toast_add);
  //                             show_toast_message();
  //                         }
  //                     }
  //                 );
  //             }
  //         }
  //     });

  //     // ON LOAD
  //     if( favourite_button.length ) {
  //         collection_favourite_sort();
  //     }

  //     $(document).ajaxComplete(function() {
  //         collection_favourite_sort();
  //     });
  // });
  /* global $ jQuery */

  jQuery(document).ready(function() {
    var product_option = $('.product-dropdown .product-option');
    if( product_option.length ) {
        product_option.each(function() {
            var
            option = $(this).find('.product-option-value'),
            name = option.html();

            switch(name) {
                case 'PBL':
                    option.html('PBL - Polished Brass Lacquered');
                    break;
                case 'PBUL':
                    option.html('PBUL - Polished Brass unlacquered');
                    break;
                case 'SBL':
                    option.html('SBL - Satin Brass Lacquered');
                    break;
                case 'SBUL':
                    option.html('SBUL - Satin Brass unlacquered');
                    break;
                case 'ABL':
                    option.html('ABL - Antique Brass Lacquered');
                    break;
                case 'ABUL':
                    option.html('ABUL - Antique Brass unlacquered');
                    break;
                case 'AMB':
                    option.html('AMB - American Bronze Lacquered');
                    break;
                case 'ANT':
                    option.html('ANT - Antique Brass unlacquered');
                    break;
                case 'ACP':
                    option.html('ACP - Antique Copper Plate');
                    break;
                case 'ASP':
                    option.html('ASP - Antique Silver Plate');
                    break;
                case 'BEL':
                    option.html('BEL - Burnished Brass');
                    break;
                case 'NBP':
                    option.html('NBP - Barrelled Nickel Plate');
                    break;
                case 'CBP':
                    option.html('CBP - Chocolate Bronze Plate');
                    break;
                case 'COP':
                    option.html('COP - Copper Plate');
                    break;
                case 'HBN':
                    option.html('HBN - Hand Burnished Nickel');
                    break;
                case 'POL':
                    option.html('POL - Polished Brass Lacquered');
                    break;
                case 'PCP':
                    option.html('PCP - Polished Chrome Plate');
                    break;
                case 'PNP':
                    option.html('PNP - Polished Nickel Plate');
                    break;
                case 'SAL':
                    option.html('SAL - Satin Antique Gloss Lacquered');
                    break;
                case 'SAS':
                    option.html('SAS - Satin Antique Satin Lacquered');
                    break;
                case 'SAT':
                    option.html('SAT - Satin Brass Lacquered');
                    break;
                case 'SCP':
                    option.html('SCP - Satin Chrome Plate');
                    break;
                case 'SCL':
                    option.html('SCL - Satin Copper Satin Lacquered');
                    break;
                case 'SNP':
                    option.html('SNP - Satin Nickel Plate');
                    break;
                case 'BMA':
                    option.html('BMA - Bronze Metal Antique');
                    break;
                case 'MBL':
                    option.html('MBL - Matt Black Lacquered');
                    break;
                case 'SBSL':
                    option.html('SBSL - Satin Brass Satin Lacquered');
                    break;
                case 'HBB':
                    option.html('HBB - HAND BURNISHED BRASS');
            }
        });
    }
  });
  /* global $ jQuery*/

  jQuery(document).ready(function() {
    // FINISHES SLIDER
    var finish_slider = $('#finishes-slider').lightSlider({
        addClass: 'finishes-style',
        item: 1,
        auto: false,
        loop: true,
        mode: 'slide',
        controls: false,
        pager: false,
        gallery: false,
        adaptiveHeight: true,
        enableTouch: false,
        enableDrag: false,
        freeMove: false,
        onSliderLoad: function() {
            change_next();
            change_previous();
            all_finishes_switcher();
            $('.lslide.active .finish-image img, .lslide.active .finish-information').addClass('active');
            $('#all-finishes-slider').scrollLeft(20);
        },
        onBeforeSlide: function() {
            $('.lslide.active .finish-image img, .lslide.active .finish-information').removeClass('active');
        },
        onAfterSlide: function() {
            setTimeout(function() {
                change_next();
                change_previous();
                $('.lslide.active .finish-image img, .lslide.active .finish-information').addClass('active');
            }, 200);
        }
    });

    var swiper = new Swiper('#all-finishes-slider', {
      slidesPerView: 4,
      slidesPerColumn: 2,
      slidesPerGroup: 4,

      pagination: {
        el: '.swiper-pagination',
        clickable: true,

      },
       navigation: {
        nextEl: '#all-finishes-control-right',
        prevEl: '#all-finishes-control-left',
      },
      breakpoints: {

        768: {
          slidesPerView: 3,
          slidesPerColumn: 1,
          slidesPerGroup: 3,
        },

      }



    });
  $(window).resize(function(){

       $(window).trigger("resize");
      });




    // FINISH IMAGE CHANGES
    function first_finish_image() {
        var first_image = $('#finishes-slider .lslide:first').find('.finish-image img').attr('src');
        $('#next-finish .controls-finish-image img').fadeOut(function() {
            $(this).attr('src', first_image).fadeIn();
        });
    }
    function last_finish_image() {
        var last_image = $('#finishes-slider .lslide:last').find('.finish-image img').attr('src');
        $('#previous-finish .controls-finish-image img').fadeOut(function() {
           $(this).attr('src', last_image).fadeIn();
        });
    }
    function previous_finish_image() {
        var previous_image = $('.lslide.active').prev().find('.finish-image img').attr('src');
        $('#previous-finish .controls-finish-image img').fadeOut(function() {
           $(this).attr('src', previous_image).fadeIn();
        });
    }
    function next_finish_image() {
        var next_image = $('.lslide.active').next().find('.finish-image img').attr('src');
        $('#next-finish .controls-finish-image img').fadeOut(function() {
           $(this).attr('src', next_image).fadeIn();
        });
    }

    // CHANGE FINISH IMAGE FUNCTION
    function change_next() {
        if( $('.lslide.active').next().length > 0 ) {
            next_finish_image();
            previous_finish_image();
        }
        else {
            first_finish_image();
            previous_finish_image();
        }
    }
    function change_previous() {
        if( $('.lslide.active').prev().length > 0 ) {
            previous_finish_image();
            next_finish_image();
        }
        else {
            last_finish_image();
            next_finish_image();
        }
    }

    // ADD CLASS TO BOTTOM SLIDER
    function all_finishes_switcher() {
        setTimeout(function() {
            var slider_id = $('#finishes-slider .lslide.active').index();
            $('#all-finishes-slider .swiper-slide').removeClass('active');
            $('#all-finishes-slider .swiper-slide').eq(slider_id - 1).addClass('active');
        }, 1000);
    }

    // SCROLL UP
    function scroll_to_finish() {
        $('html, body').animate({
            scrollTop: $('#finishes-slider').offset().top - 80
        }, 500);
    }

    // CHEVRON SLIDER FUNCTIONS
    $('#next-finish').on('click', function() {
        finish_slider.goToNextSlide();
        scroll_to_finish();
    });
    $('#previous-finish').on('click', function() {
        finish_slider.goToPrevSlide();
        scroll_to_finish();
    });
    $('#next-finish, #previous-finish').on('click', function() {
        all_finishes_switcher();
    });
    $('#all-finishes-slider .swiper-slide').on('click', function() {
        var finish_id = $(this).index() + 1;
        finish_slider.goToSlide(finish_id);
        $('#all-finishes-slider .swiper-slide').removeClass('active');
        $(this).addClass('active');


    });

  });

  jQuery(document).ready(function() {
    // DISABLE AJAX CACHE
    $.ajaxSetup({ cache: false });

    var close_nav = function() {
        $('body').removeClass('no-scroll');
        $('#mobile-navigation, #menu .bar, #menu #bars, .sub-menu, .link-has-children').removeClass('active');
        $('#mobile-navigation, #menu .bar, #menu #bars, .sub-menu-lvl2, .link-has-children').removeClass('active');
    };
    var open_nav = function() {
        $('#mobile-navigation').addClass('active');
        $('body').addClass('no-scroll');
        $('#menu .bar').addClass('active');
        $('#menu #bars').addClass('active');
    };

    // IF CLICK OUTSIDE NAV
    $('main').on('click', function() {
        close_nav();
    });

    // MENU BUTTON
    $('#menu').on('click', function() {
        if( $('#mobile-navigation').hasClass('active') ) {
            close_nav();
          $('body').css('overflow', "scroll");
        }
        else {
            open_nav();
          $('body').css('overflow', "hidden");
        }
    });







    // SUB NAV
    $('.link-has-children').hover( function(e) {
        // IF DESKTOP
        if( $(window).width() >= 1200 ) {
            var child_id = $(this).data("value");

            // IF SUB MENU OPEN
            if( $('#' + child_id).hasClass('active') && !$('.sub-menu-lvl2').hasClass("active")) {
                $(this).removeClass('active');
                $('#' + child_id).removeClass('active');
                $('.nav-overlay').removeClass('active');
            }
            else {
                if($('.sub-menu-lvl2:not(.active)') && $('.sub-menu').hasClass("active")){
                $('.link-has-children').removeClass('active');
                $('.sub-menu').removeClass('active');
                $('.nav-overlay').removeClass('active');
                return;
                }
                $(this).addClass('active');
                $('#' + child_id).addClass('active');
                $('.nav-overlay').addClass('active');
            }
        }

        // IF MOBILE
        else {
            // IF SUB MENU OPEN
            if($('.sub-menu-lvl2').hasClass("active")  && $('.sub-menu').hasClass("active")) {
                $(this).removeClass('active');
                $(this).find('.sub-menu').removeClass('active');

            }
            else if(!$('.sub-menu').hasClass("active")){

                $('.link-has-children').removeClass('active');
                $('.link-has-children .sub-menu').removeClass('active');
                $("#main-navigation").animate({"left":"-100vw"},{ queue : false});
                $("#main-navigation").css("background-color","#a0a0a0");
                $("#main-navigation").css("overflow-y","visible");
                $("#main-navigation #navigation-contents > li").css("border-color","#a0a0a0");
                $(this).addClass('active');
                $(this).find('.sub-menu').addClass('active');

            }
            else{
               $(this).find('.sub-menu').removeClass('active');
              $("#main-navigation").removeAttr("style");
              $("#main-navigation #navigation-contents > li").removeAttr("style");
            }
        }
    });

      // SUB NAV LEVEL 2
      $('.link-has-children-lvl2').on('click', function(e) {
        // IF DESKTOP
        if( $(window).width() >= 1200 ) {
            var child_id = $(this).data("value");

            // IF SUB MENU OPEN
            if( $('#' + child_id).hasClass('active') ) {
                $(this).removeClass('active');
                $('#' + child_id).removeClass('active');
                e.stopPropagation();
            }
            else {
                $('.link-has-children-lvl2').removeClass('active');
                $('.sub-menu-lvl2').removeClass('active');
                $(this).addClass('active');
                $('#' + child_id).addClass('active');
                e.stopPropagation();
            }
        }

        // IF MOBILE
        else {
            // IF SUB MENU OPEN
            if( $(this).find('.sub-menu-lvl2').hasClass('active') ) {
                $(this).removeClass('active');
                $(this).find('.sub-menu-lvl2').removeClass('active');
                e.stopPropagation();
            }
            else {
                $('.link-has-children-lvl2').removeClass('active');
                $('.link-has-children-lvl2 .sub-menu-lvl2').removeClass('active');
                $(this).addClass('active');
                $(this).find('.sub-menu-lvl2').addClass('active');
                e.stopPropagation();
            }
        }
    });

    $('.link-has-children > a').on('click', function(e) {
        e.preventDefault();
    });
  });

  /* global $ jQuery */

  jQuery(document).ready(function() {
    // FIND AND SHOW
    $('.global-modal-link').on('click', function() {
        var this_link = $(this);
        var id = this_link.attr('id');
        $('.global-modal').each(function() {
            var this_modal = $(this);
            if (this_modal.attr('data-modal') == id) {
                this_modal.addClass('active');
            }
        });
        $('body').addClass('noscroll');
    });
    $('.global-modal-close').on('click', function() {
        $('.global-modal').removeClass('active');
    });
    $(document).mouseup(function(e) {
    var container = $(".global-modal-box");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('.global-modal').removeClass('active');
      $('body').removeClass('noscroll');
    }
  });
  });


  /* global $ jQuery */

  jQuery(document).ready(function() {
    var wait = (function() {
        var reset = 0;
        return function(callback, ms) {
            clearTimeout(reset);
            reset = setTimeout(callback, ms);
        };
    })();

    // NUMERICAL FIELD ONLY
    $('.cart-item-quantity-field').numeric();
  });

  /* global $ jQuery */

  // SCROLL TO TOP
  jQuery(document).scroll(function() {
    var
    scrollTop = $(this).scrollTop(),
    slider = $('#slider-feature'),
    distance = 600;


    if( slider.length ) {
        if( scrollTop >= slider.offset().top - distance) {
            $("#slider-feature #slider-panel, #slider-feature #global-slider-contents").addClass('scrolled');
        }
    }
  });

  // SCROLL TO FORM
  jQuery(window).on('load', function() {
    if( window.location.href.indexOf('contact_posted=true') > -1 ) {
        var literature = $('#literature-request-thankyou');
        var literature_pdf = literature.data('pdf');

        $('html, body').animate({
            scrollTop: $('.contact-form').offset().top - 250
        }, 1000);
    }
  });

  $(document).ready(function() {
    var
    search = $('#search-button'),
    modal = $('#search-modal'),
    close = $('#search-modal-close');
    type = $('#search-modal-field');

    search.on('click', function() {
        modal.addClass('active');
        close.addClass('noscroll');
        setTimeout(function() {
            $('#search-modal-field').focus();
        }, 1000);
    });

    close.on('click', function() {
        modal.removeClass('active');
        close.removeClass('noscroll');
    });

    $(document).keyup(function(e) {
        if(e.which == 27) {
            close.click();
        }
    });
  });

  jQuery(window).on('load', function() {
    var addToMailing = sessionStorage.getItem('add_to_mailing');
    var emailToAdd = sessionStorage.getItem('email_to_add');
    var newsletterSuccess = window.location.href.indexOf('result=success') > -1;

    if( addToMailing ) {
        sessionStorage.removeItem('add_to_mailing');
        sessionStorage.removeItem('email_to_add');
        $('#newsletter-email').val(emailToAdd);
        $('#newsletter-submit').click();
    }

    if( newsletterSuccess ) {
        $('#signup-form').replaceWith('<p>Thanks for signing up to our newsletter.</p>');
        $('html, body').animate({
            scrollTop: $('#contact').offset().top
        }, 1000);
    }
  });

  /* global $ jQuery*/

  jQuery(document).ready(function() {
    // SLIDER FEATURE
    $('#global-slider').lightSlider({
        addClass: 'slider-feature',
        item: 1,
        speed: 2500,
        auto: true,
        loop: true,
        mode: 'fade',
        cssEasing: 'cubic-bezier(0.32, 0.75, 0, 1)',
        pause: 7000,
        controls: false,
        pager: false,
        gallery: false,
        verticalHeight: 350,
        enableTouch: false,
        enableDrag: false,
        freeMove: false
    });

    // TWO PANEL SLIDER FEATURE
    $('#two-column-slider').lightSlider({
        addClass: 'two-column-links-style',
        item: 1,
        speed: 2500,
        auto: true,
        loop: true,
        mode: 'fade',
        pause: 7000,
        controls: false,
        pager: false,
        gallery: false,
        verticalHeight: 200,
        enableTouch: false,
        enableDrag: false,
        freeMove: false
    });

    // LATEST NEWS FEATURE
    $('#news-slider').lightSlider({
        addClass: 'news-slider-style',
        item: 1,
        speed: 400,
        loop: true,
        mode: 'slide',
        controls: false,
        pager: true,
        gallery: false,
        adaptiveHeight: true
    });
  });

  /* TWITTER
  window.twttr = (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {};
  if (d.getElementById(id)) return t;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://platform.twitter.com/widgets.js";
  fjs.parentNode.insertBefore(js, fjs);

  t._e = [];
  t.ready = function(f) {
    t._e.push(f);
  };

  return t;
  }(document, "script", "twitter-wjs"));


  // When the user scrolls down 20px from the top of the document, show the button
  window.onscroll = function() {scrollFunction()};

  function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    $("#sect-right").css("margin","15px 50px");
    $("#sect-left").css("margin","15px 50px");
    $("header #logo").css("padding","13px");
    $("header #logo img").css("width","100px");
  } else {
      $("#sect-right").css("margin","30px 50px");
    $("#sect-left").css("margin","30px 50px");
    $("header #logo img").css("width","140px");
    $("header #logo").css("padding","18px");

  }
  }
  */


  $(document).on('click','.finish-modal-link .product-image',function(e) {
        var this_link = $(this);
        var id = $(this_link).parent().attr('id');
        $('.global-modal').each(function() {
            var this_modal = $(this);
            if (this_modal.attr('data-modal') == id) {
                this_modal.addClass('active');
            }
        });
        $('body').addClass('noscroll');
    });
  $(document).on('click','.global-modal-close',function(e) {

        $('.global-modal').removeClass('active');
        $('body').removeClass('noscroll');
    });


   /*$(document).on('click','.buy-finish',function(e) {

        $.post('/cart/add.js', {
            quantity: 1,
            id: $(this).data("linked"),
            beforeSend: function() {
                $(e.currentTarget).text("Adding to cart");
            },
            success: function(data) {
                $(e.currentTarget).text("Added to cart");

                var cartCount =  parseInt($("#cart-amount-1").text()) + 1;
                $("#cart-amount-1").text(cartCount);
                $("#cart-amount-2").text(cartCount);
            }
        });

    });*/



  $(window).on("load", function(){
  $( ".lSPager" ).each(function( index ) {
  var count = $(this).children().length;

  if(count <= 1){
    $(this).hide();

  }

  });

    var hTop = $('.v2-header').outerHeight();


    if ($(window).width() > 1023) {
       $("#wrapper").css("padding-top",hTop);
    }
    else {
       $("#wrapper").css("padding-top",hTop);
    }

    const currentCurrency = $('.currency-option.active').attr('id');

    if(currentCurrency) {
        sessionStorage.setItem('currency', currentCurrency);
      } else if(typeof currentCurrency === 'undefined') {
          sessionStorage.setItem('currency', 'gbp');
    }

  });



  $( window ).resize(function() {
    var hTop = $('.v2-header').outerHeight();


    if ($(window).width() > 1023) {
       $("#wrapper").css("padding-top",hTop);
    }
    else {
       $("#wrapper").css("padding-top",hTop + bTop-1);
    }
  });


  $(function(){

    $("#scroll-top").click(function(){
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
    });

    var lastScrollTop = 0;

    var ua = window.navigator.userAgent;
    var isIE = /MSIE|Trident/.test(ua);

    // $(window).scroll(function(){
    //   var bTop = $('#banner-message').outerHeight();
    //   $('#banner-message').css('transition','opacity 0.5s ease-in-out');
    //     if ( !isIE ) {
    //         var hTop = $('.v2-header').height();
    //         var minusHeader = hTop-hTop*2;

    //         var st = $(this).scrollTop();
    //         if (st > lastScrollTop && st >= hTop){
    //             if ($(window).width() > 1023) {
    //                 $('.v2-header').css({ top: minusHeader });

    //             }  else{
    //                 $('#banner-message').css('opacity','0');
    //                 $('wrapper').css('padding-top', hTop);
    //             }
    //             $('.boost-pfs-filter-toolbar-sticky-mobile .boost-pfs-filter-toolbar-show-sort-by-mobile').css({ top: bTop });


    //         }
    //         else{
    //             if ($(window).width() > 1023) {
    //                 $('.v2-header').css({ top: 0 });
    //             }else{
    //                 $('#banner-message').css('opacity','1');
    //                 $('wrapper').css('padding-top', hTop + bTop);

    //             }
    //             $('.boost-pfs-filter-toolbar-sticky-mobile .boost-pfs-filter-toolbar-show-sort-by-mobile').css({ top: 105 });

    //         }

    //         lastScrollTop = st;
    //     }

    //     if(st >= hTop){
    //         $("#scroll-top").css("visibility","visible");
    //         $("#scroll-top").css("opacity","1");
    //     }
    //     else{
    //         $("#scroll-top").css("visibility","hidden");
    //         $("#scroll-top").css("opacity","0");
    //     }
    // });
  });
